/** @internal — only for use within useHomePageOrchestrator */
import type { ColumnStatistic } from '#types';

export type PersistedHomePageState = {
  version: 1;
  activeView: string;
  baseFormView: string;
  selectedCustomViewId?: string;
  columnFilters: Array<{ id: string; value: unknown }>;
  sorting: Array<{ id: string; desc?: boolean }>;
  columnVisibility: Record<string, boolean>;
  columnSizing: Record<string, number>;
  columnOrder: string[];
  columnStatistics: Record<string, ColumnStatistic>;
};

export const STORAGE_KEY_PREFIX = 'homePageTableState';

export function loadPersistedState(userId: string): PersistedHomePageState | null {
  try {
    const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}-${userId}`);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (parsed?.version !== 1) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function persistState(userId: string, state: PersistedHomePageState): void {
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}-${userId}`, JSON.stringify(state));
  } catch {
    // Storage unavailable
  }
}
